import NetworkDetails from "./details"
import { Consumer, Provider, NetworkDetailsContext } from "./details.context"

export { Consumer, Provider, NetworkDetailsContext }
export default NetworkDetails
